/**
 * Sysnet API
 *  ## Authorization We use bearer auth throughout the API. Generally, API requests should have the follow header:   {       \"content-type\": \"application/json\",       \"Authorization\": \"Bearer TOKEN_GOES_HERE\"   }   Please refer to the Auth section immediately below for details on getting your token.
 *
 * OpenAPI spec version: 1.0.4
 * Contact: support@hlpos.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { CreateDateTime } from './createDateTime';
import { LastUpdateByUserId } from './lastUpdateByUserId';
import { UpdateDateTime } from './updateDateTime';

/**
 * Stores template information including filter settings and column settings for each report. Report Template belongs to a single venue
 */
export interface ReportTemplateView { 
    /**
     * Primary Key for the template.
     */
    reportTemplateId?: number;
    /**
     * Name of the template. Unique with report_id + venue_ref_id.
     */
    reportTemplateName?: string;
    /**
     * Type of report.
     */
    reportId?: number;
    venueId?: string;
    /**
     * Can only have one default template for a venue and report.
     */
    isDefault?: boolean;
    createDateTime?: CreateDateTime;
    updateDateTime?: UpdateDateTime;
    /**
     * References user who created the template.
     */
    createdBy?: string;
    lastUpdateByUserId?: LastUpdateByUserId;
}